/**
 * Created by: cparaschiv
 * Date: 29.05.2013, 11:40
 */

/**
 * @class TS.domain.properties.BrowseListProperty
 * @extends TS.domain.properties.SelectionListProperty
 * @classdesc Similar to {@link TS.domain.properties.SelectionListProperty SelectionListProperty}, but has the ability to push multiple values
 * into the model when the user selects an item.
 */
TS.domain.properties.BrowseListProperty = new Class(
/** @lends TS.domain.properties.BrowseListProperty# */
{
    Extends: TS.domain.properties.SelectionListProperty,

    browseUrl: null,

    initialize: function (domain, config) {
        var me = this;
        me.parent(domain, config);

        me.browseUrl = TS.unwrap(TS.Util.removeTrailingSlash(domain.rootUrl)) + '/' + 'BrowseProperty?propertyName=' + me.Name;
    },

});

TS.ObjectFactory.map('BrowseListProperty', TS.domain.properties.BrowseListProperty);
